export default __webpack_public_path__ + "static/media/isb-grey.a8495669.svg";